<!-- The slide and the four promises as the theme draws them (the owner, 2026-10-15). The hero fragment's words would
     sit on the slide's own lettering, so they are the page's title and description only (applyFragments). -->
<app-block-slideshow [withDepartments]="true"></app-block-slideshow>

<app-block-features></app-block-features>

<!-- <app-ad-banner [banner]="adBanner"></app-ad-banner> -->

<app-block-products-carousel
    [header]="titles['fresh-finds']"
    layout="grid-4"
    [loading]="featuredProducts.loading"
    [products]="featuredProducts.products"
    [groups]="featuredProducts.groups"
    (groupChange)="groupChange(featuredProducts, $event)"
></app-block-products-carousel>

<!-- <app-ad-banner [banner]="adBanner2"></app-ad-banner> -->
<app-block-banner></app-block-banner>

<app-block-products [header]="titles['spotlight']"
    layout="large-first" 
    [products]="columnLatestProducts">
</app-block-products>

<app-block-categories [header]="'trending-categories' | t:'Trending Categories'" layout="compact"></app-block-categories>

<!-- <app-ad-banner [banner]="adBanner"></app-ad-banner> -->

<app-block-products-carousel
    [header]="titles['premium']"
    layout="horizontal" 
    [rows]="2"
    [loading]="latestProducts.loading"
    [products]="latestProducts.products"
    [groups]="latestProducts.groups"
    (groupChange)="groupChange(latestProducts, $event)"
></app-block-products-carousel> 

<!-- Shops to follow (ShopFront/ToFollow, the owner's rule: best delivered rate among shops with enough delivered orders).
     Drawn on the server and carried to the browser, which does not ask again; hidden while no shop qualifies. -->
<div class="block home-shops" *ngIf="shopsToFollow.length">
    <div class="container">
        <div class="block-header">
            <h3 class="block-header__title">{{ 'shops-to-follow' | t:'Shops to follow' }}</h3>
            <div class="block-header__divider"></div>
            <a *ngIf="shopsDirectory$ | async" class="home-shops__all" routerLink="/shops">{{ 'all-shops' | t:'All shops' }}</a>
        </div>
        <ul class="home-shops__list">
            <li *ngFor="let shop of shopsToFollow" class="home-shops__item">
                <app-shop-card [shop]="shop" [level]="4"></app-shop-card>
            </li>
        </ul>
    </div>
</div>

<app-block-posts [header]="'home-learn-about-life-style' | t:'Learn about life style'" layout="list-sm" [posts]="posts$|async"></app-block-posts>

<app-block-recent-products></app-block-recent-products>

<!-- How it works (the "home.how" fragment): its steps in a row of three, numbered - at the foot of the page, the products
     first (the owner, 2026-10-15). -->
<div class="block home-how" *ngIf="how?.steps?.length" [attr.lang]="lang">
    <div class="container">
        <h2 class="home-how__title" *ngIf="how.heading">{{ how.heading }}</h2>
        <ol class="home-how__steps">
            <li class="home-how__step" *ngFor="let step of how.steps; let i = index">
                <span class="home-how__number" aria-hidden="true">{{ i + 1 }}</span>
                <div class="home-how__text typography" appRouterLinks [innerHTML]="step | siteHtml"></div>
            </li>
        </ol>
    </div>
</div>
<!-- <app-block-brands></app-block-brands> -->

<!-- <app-block-product-columns>
    <app-block-product-columns-item header="Top Rated Products" [products]="columnTopRated$|async"></app-block-product-columns-item>
    <app-block-product-columns-item header="Latest" [products]="columnSpecialOffers$|async"></app-block-product-columns-item>
    <app-block-product-columns-item header="Most Wanted" [products]="columnBestsellers$|async"></app-block-product-columns-item>
</app-block-product-columns> -->
